import { useState } from 'react';

// Sous-hook Messagerie : gestion des filtres et de la recherche de la liste d'emails.
// Reçoit `setEmailsPage` pour réinitialiser la pagination à chaque changement de filtre.
export function useMailFilters({ setEmailsPage }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    readStatus: 'all', // 'all', 'read', 'unread'
    dateFrom: '',
    dateTo: '',
    hasAttachments: false,
    isImportant: false,
    linkedToCRM: false,
    notLinkedToCRM: false,
    includeArchived: false
  });

  const resetFilters = () => {
    setFilters({
      readStatus: 'all',
      dateFrom: '',
      dateTo: '',
      hasAttachments: false,
      isImportant: false,
      linkedToCRM: false,
      notLinkedToCRM: false,
      includeArchived: false
    });
    setEmailsPage(1);
  };

  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    setEmailsPage(1);
  };

  const hasActiveFilters = () => {
    return filters.readStatus !== 'all' ||
           filters.dateFrom ||
           filters.dateTo ||
           filters.hasAttachments ||
           filters.isImportant ||
           filters.linkedToCRM ||
           filters.notLinkedToCRM ||
           filters.includeArchived;
  };

  return {
    searchQuery, setSearchQuery,
    showFilters, setShowFilters,
    filters, setFilters,
    resetFilters, updateFilters, hasActiveFilters
  };
}
